import { Alert, Box, Chip } from "@mui/material";
import {
	BooleanField,
	DateField,
	DeleteButton,
	EditButton,
	EmailField,
	Show,
	SimpleShowLayout,
	TextField,
	TopToolbar,
	useRecordContext,
} from "react-admin";
import { RestoreButton } from "@/components/RestoreButton";

const AppShowActions = () => {
	const record = useRecordContext();

	return (
		<TopToolbar>
			<EditButton />
			{record?.deletedAt ? <RestoreButton resource="apps" /> : <DeleteButton />}
		</TopToolbar>
	);
};

const DeletedAlert = () => {
	const record = useRecordContext();
	if (!record?.deletedAt) return null;

	return (
		<Alert severity="warning" sx={{ mb: 2 }}>
			This app was deleted on {new Date(record.deletedAt).toLocaleDateString()}.
		</Alert>
	);
};

const PlatformsField = () => {
	const record = useRecordContext();
	if (!record?.platforms?.length) return null;

	return (
		<Box sx={{ display: "flex", gap: 1 }}>
			{record.platforms.map((platform: string) => (
				<Chip key={platform} label={platform} size="small" />
			))}
		</Box>
	);
};

export const AppShow = () => (
	<Show actions={<AppShowActions />}>
		<DeletedAlert />
		<SimpleShowLayout>
			<TextField source="id" />
			<TextField source="name" />
			<TextField source="ownerId" label="Owner ID" />
			<EmailField source="ownerEmail" label="Owner Email" />
			<BooleanField source="active" />
			<BooleanField source="testMode" label="Test Mode" />
			<TextField source="attributionMode" label="Attribution Mode" />
			<TextField source="attestationProvider" label="Attestation Provider" />
			<TextField source="iapProvider" label="IAP Provider" />
			<PlatformsField />
			<TextField
				source="allowedCorsOrigins"
				label="CORS Origins"
				emptyText="-"
			/>
			<TextField
				source="stripeAccountId"
				label="Stripe Account"
				emptyText="-"
			/>
			<DateField source="createdAt" label="Created" showTime />
			<DateField source="archivedAt" label="Archived" showTime emptyText="-" />
			<DateField source="deletedAt" label="Deleted" showTime emptyText="-" />
		</SimpleShowLayout>
	</Show>
);
